import clsx from 'clsx'
import { ChatMiddlewareIcon } from '../../ChatMiddlewareIcon'
import { ChatEngineTrace } from '../ChatEngineTraceViewer'

type CompleteTraceViewProps = {
  trace: ChatEngineTrace
  selectedStepIndex: number | null
  setSelectedStepIndex: (index: number) => void
}

export function CompleteTraceView (props: CompleteTraceViewProps) {
  const { trace, selectedStepIndex, setSelectedStepIndex } = props

  return (
    <>
      {trace.steps.map((step, index) => (
        <div
          key={index}
          className={clsx(
            'px-2',
            'py-1',
            'cursor-pointer',
            'w-max',
            'hover:bg-base-200',
            selectedStepIndex === index && 'bg-base-200'
          )}
          onClick={() => setSelectedStepIndex(index)}
        >
          <div style={{ marginLeft: `${step.depth * 16}px` }}>
            <div className="flex gap-2 items-center">
              <div className="bg-yellow-200 p-1 rounded">
                <ChatMiddlewareIcon type={step.type ?? step.name as any}/>
              </div>
              <span className="text-sm truncate">{step.name}</span>
              <span className="text-xs opacity-40">{step.duration?.toFixed(1)}ms</span>
              <span className="text-xs opacity-70 grow">
                {step.events?.length === 1 && '1 event'}
                {step.events?.length && step.events.length > 1 && `${step.events?.length} events`}
              </span>
              <span className="text-xs opacity-40">{step.type}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
